<template>
  <a-select
    :mode="mode"
    v-model:value="valueState"
    style="width: 300px"
    placeholder="Pilih Regional"
    allow-clear
    :show-arrow="true"
    :not-found-content="loading ? undefined : 'Tidak ditemukan'"
    option-filter-prop="label"
    option-label-prop="label"
    @search="onSearch"
    @select="() => (findText = null)"
    show-search
    v-bind="$attrs"
  >
    <a-select-option v-for="d in items" :key="all ? d.name : d.id" :label="d.name">
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="highlight(d.name)"></span>
      <!--eslint-enable-->
    </a-select-option>
    <template v-if="loading" #notFoundContent>
        <ASpin size="small" />
    </template>
  </a-select>
</template>

<script>
import { onMounted, ref, toRefs, defineComponent } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'

export default {
  props: {
    value: { type: [Array, Number, Object, String], default: null },
    mode: {
      default: 'multiple',
      type: String,
    },
    all: [Boolean],
  },
  emits: ['update:value'],
  setup(props) {
    const loading = ref(false)
    const items = ref([])
    const findText = ref(null)
    const { all } = toRefs(props)

    const fetch = () => {
      loading.value = true
      apiClient.get(`/api/filter/${all ? 'region' : 'region-by-role'}?active=1`).then(response => {
        const sorted = response.data
        items.value = sorted.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
      })
      .finally(() => {
        loading.value = false
      })
    }
    onMounted(() => {
      fetch()
    })

    const onSearch = value => {
      findText.value = value
    }

    const highlight = value => {
      return value.replace(new RegExp(findText.value, 'gi'), match => {
        return `<span style="background-color: yellow;">${match}</span>`
      })
    }
    return { items, valueState: useVModel(props, 'value'), findText, highlight, onSearch, loading }
  },
}
</script>

<style></style>
